import topTitle from '@/views/template/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [{
        name: '方案一',
        list: [{
          name: '意外身故',
          value: '30万',
          info: ''
        }, {
          name: '意外伤残',
          value: '20万',
          info: '权益说明：权益说明',
          isClick: false
        }, {
          name: '意外伤残',
          value: '20万',
          info: '22'
        }]
      }, {
        name: '方案二',
        list: [{
          name: '意外身故',
          value: '30万',
          info: ''
        }, {
          name: '意外伤残',
          value: '20万',
          info: '权益说明：权益说明',
          isClick: false
        }, {
          name: '意外伤残',
          value: '20万',
          info: '22'
        }]
      }, {
        name: '方案三',
        list: [{
          name: '意外身故',
          value: '30万',
          info: ''
        }, {
          name: '意外伤残',
          value: '20万',
          info: '权益说明：权益说明',
          isClick: false
        }, {
          name: '意外伤残',
          value: '20万',
          info: '22'
        }]
      }],
      tabIndex: 0
    };
  },
  methods: {
    infoClickFun(index) {
      this.list[this.tabIndex].list[index].isClick = !this.list[this.tabIndex].list[index].isClick;
    }
  }
};